import * as React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import { getUserName } from "../../Storage/Datastore";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#ffffff",
    color: "white",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    marginLeft: 85,
    position: "relative",
    bottom: "55px",
    borderRadius: 10,
    cursor: "pointer",
  },
}));

export default function Tooltips() {
  const userName = getUserName();
  return (
    <Grid>
      <HtmlTooltip
        title={
          <React.Fragment>
            <Grid
              container
              justifyContent={"center"}
              alignItems={"center"}
              height={"45px"}
            >
              <Grid
                sx={{
                  width: 15,
                  height: 15,
                  backgroundColor: "#ffffff",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  position: "relative",
                  right: 13,
                  transform: "rotate(48deg)",
                }}
              ></Grid>
              <Grid
                sx={{
                  width: 35,
                  height: 35,
                  backgroundColor: "#17dfba",
                  borderRadius: 100,
                  display: "flex",
                  position: "relative",
                  right: 10,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography color="inherit">{userName.charAt(0)}</Typography>
              </Grid>
              <Typography
                color="black"
                marginX={"5px"}
                sx={{ position: "relative", right: 5 }}
              >
                {userName}
              </Typography>
            </Grid>
          </React.Fragment>
        }
      >
        <Button sx={{ color: "white" }}>{userName.charAt(0)}</Button>
      </HtmlTooltip>
    </Grid>
  );
}
